import styled from 'styled-components';

export const DataIntegrationSection = styled.section`
    width: 100%;

    .title-sub-page{
        @media screen and (max-width: 991px){
            margin-top: 20px;
        }

        @media screen and (max-width: 767px){
            margin-bottom: 20px;
        }
    }
`;

export const DataIntegrationMain = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;

    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }
`;

export const DataIntegrationWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: -125px;
    padding: 20px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 20px;

    @media screen and (max-width: 991px){
        flex-direction: column;
    }
`;

export const DataIntegrationImage = styled.div`
    width: calc(50% - 10px);
    border-radius: 10px;
    display: inline-block;
    overflow: hidden;
    
    @media screen and (max-width: 991px){
        width: 100%;
    }

    img{
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
    }
`;

export const DataIntegrationContent = styled.div`
    width: 100%;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
    
    @media screen and (max-width: 575px){
        font-size: 16px;
        line-height: 24px;
    }
`;

export const DataIntegrationText = styled.p`
    margin: 0;
`;

export const DataIntegrationButton = styled.div`
    margin-top: 30px;

    @media screen and (max-width: 575px){
        margin-top: 20px;
    }

    button{
        padding: 12px 45px;
        box-shadow: 3px 5px 20px #00000033;
        
        @media screen and (max-width: 575px){
            width: 100%;
            padding: 12px 20px;
        }
    }
`;